export default __webpack_public_path__ + "static/media/schweizereid.82834dff.png";